// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "Prarthana Vidya Mandir School",
    contact: "+91 76763 23184 | pvmschool@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/prarthanaschoolmuddebihal/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/",
      facebook:   "https://www.facebook.com/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
